import React, { useEffect, useState } from "react";
import { CREATE_RECIPIENTS_IN_CAMPAIGN_LINK } from "../../constants/constants";
import { notifyError, notifySuccess } from "../../helper";
import Header from "../Header";
import Footer from "../Footer";
import Sidebar from "../Sidebar";
import Tabs from "./Tabs";
import client from "../../api";
import FormValidator from "../../FormValidator";
import { useParams } from "react-router-dom";
import BlockLoader from "../BlockLoader";

const EditCampaign = () => {
    const api = client();
    const {campaignID} = useParams('');
    const [campaignPreview,setCampaignPreview] = useState({});
    const [contactEmails, setContactEmails] = useState();
    const [formData, setFormData] = useState({campaignname:'',contactEmailId:'',use_smtp:false});
    const [smtpAccount, setSmtpAccount] = useState([]);
    const [formLoader, setFormLoader]= useState(true);
    const [loading,setLoading] = useState(false);
    const [error, setError] = useState({});
    const validatorRules = {
        campaignname: {
            empty: "Please Enter Campaign Name"
        },
        contactEmailId:{
            empty: "Please Select Mail Account"
        }
    }
    const validatorObject = new FormValidator(validatorRules);
    
    const removeError = (e) => {
        setError({ ...error, [e.target.name]: "" });
    }

    const fieldBlur = e => {
        const fieldError = validatorObject.validateFields(e.target.value, e.target.name)
        if (Object.keys(fieldError).length) setError({ ...error, ...fieldError });        
    }

    const fieldFocus = e => {
        removeError(e);
        //update()
    }

    const validateAllFields = (inputs) => {
        const v = validatorObject.validateFields(inputs);
        if(Object.keys(v).length === 0){
            return true;
        } else {
            setError({...v});
            return false;
        }       
    }

    const hasSMTP = (item,value) => {
        return item.id === value;
    }

    const handleInputChange = (e) => {
        const {name,value}= e.target;
        if(name === 'use_smtp'){
            setFormData((prevData)=>({
                ...prevData,
                [name]:e.target.checked,
            }));
        } else {
            setFormData((prevData)=>({
                ...prevData,
                [name]:value,
            }));
        }
        if(name === 'contactEmailId'){
            const has_smtp = contactEmails.filter(item => hasSMTP(item, value));
            setSmtpAccount(has_smtp);
        }
    }

    const filterValues = (inputValues) => {
        //Edit campaign case: don't need to send current_tab and completed_tab keys.
       const tempPayload = (Object.keys(campaignPreview).length && campaignPreview?.completed_tab.length) ? ({
            id: campaignID,
            name: inputValues.campaignname,
            assigned_to:inputValues.contactEmailId,
            use_smtp:inputValues.use_smtp            
        }) : ({
            id: campaignID,
            name: inputValues.campaignname,
            assigned_to:inputValues.contactEmailId,
            current_tab:"add-recipients",
            completed_tabs:["start"],
            use_smtp:inputValues.use_smtp            
        });

        return tempPayload;
  
    };

    const updateCampaign = async () => {
        setLoading(true);
        try{
            if(validateAllFields(formData)){
                const filteredData = filterValues(formData);
                const response = await api.post('/v1/campaign/update',{
                    ...filteredData
                });
                
                if(response.status === 200 || response.status === 201){
                    setLoading(false);
                        notifySuccess('Campaign Updated Successfully...!');
                        const redirectUrl = CREATE_RECIPIENTS_IN_CAMPAIGN_LINK.replace(':campaignID',campaignID);
                        setTimeout(()=>{
                            window.location.href = redirectUrl;
                        },2500);
                                        
                }
            } else {
                setLoading(false);
            }
        } catch (error){
            setLoading(false);
            if(error.status === 400) notifyError('Bad Request. Not able to create campaign. Please try again');            
        }        
    }

    useEffect(()=>{
        const getAllContactList = async () => {
            try{
                const response = await api.get('/v1/mailAccount/list');
                if(response.status === 200 || response.status === 201){
                    setContactEmails(response.data.data);                                      
                }
            } catch(error){
                console.log('error.message',error);
                if(error.status === 400){
                    notifyError('Bad Request. Not able to fetch Contact Emails. Please try again');
                }  
            } finally{
                setFormLoader(false);
            }
        }
        getAllContactList();
    },[]);

    useEffect(()=>{
        const getCampaignPreview = async () => {
            try{
                const response = await api.post('/v1/campaign/preview',{ campaign_id:campaignID });
                if(response.status === 200 ||response.status === 201 ){
                    setCampaignPreview(response.data.campaignPreview);
                    setFormData({...formData, ...{
                        campaignname: response?.data?.campaignPreview?.name,
                        contactEmailId: response?.data?.campaignPreview?.assigned_to_user?._id,
                        use_smtp: response?.data?.campaignPreview?.setting?.use_smtp}});                        
                }

            } catch (error){
                console.log('error.message',error);
                if(error.status === 4000) notifyError('Bad Request. Not able to fetch Campaign Preview. Please try again');
            } finally{
                setFormLoader(false);
            }
        }        
        getCampaignPreview();        
    },[]); 

    useEffect(()=>{
        const has_smtp = contactEmails !== undefined && contactEmails.filter(item => (item.id === formData.contactEmailId));
        setSmtpAccount(has_smtp);                
    },[contactEmails,formData]);
    
    return(<>
        <Header/>
        <div className="main-page">
            <Sidebar/>
           <div className="campaign-create-steps">
                <div className="top-section">
                    <h1>Add Campaign </h1>                
                </div>
                <div className="steps-wrap">
                    <Tabs currentTab="start" completedTabs={campaignPreview.completed_tab} />
                    {formLoader ?<div className="step-start-loader"><BlockLoader/></div> : <div className="step-start">
                        <h2>Let's get started!</h2>
                        <div className="step-forms">
                            <div className="field-wrap">
                                <label className="label-xs"> Title (for your team's eyes only)</label>
                                <input 
                                    type="text"
                                    name="campaignname" 
                                    placeholder="Campaign Title"
                                    value={formData.campaignname}
                                    onChange={handleInputChange}
                                    onBlur={fieldBlur}
                                    onFocus={fieldFocus} 
                                />
                                {error.campaignname && <span className="validation-error">{error.campaignname}</span>}
                            </div>
                            <div className="field-wrap">
                                <label className="label-xs"> From address </label>
                                <select 
                                    className="selectbox" 
                                    name="contactEmailId"
                                    onChange={handleInputChange}
                                    onBlur={fieldBlur}
                                    onFocus={fieldFocus}
                                    value={formData.contactEmailId}
                                    >
                                    <option value={''}>Select a From Address</option>
                                    {contactEmails && contactEmails.map((value,index)=> (<option key={index} value={value.id}>{value.email}</option>))}
                                </select>
                                {error.contactEmailId && <span className="validation-error">{error.contactEmailId}</span>}
                            </div>
                            
                            {(smtpAccount.length && smtpAccount[0].has_smtp) ? <div className="field-wrap">                                
                                <label className="label-xs center" htmlFor="use-smtp"> 
                                    <input 
                                        type="checkbox" 
                                        name="use_smtp" 
                                        id="use-smtp"
                                        checked={formData.use_smtp} 
                                        onChange={handleInputChange}
                                        />  Use SMTP 
                                </label>
                            </div>:''}

                            <div className="field-wrap align-center">
                                <button 
                                    type="button" 
                                    className={loading ? "next-btn button--loading":"next-btn"}
                                    onClick={()=>updateCampaign()}>
                                        <span className="button--text">Next</span>
                                </button>
                            </div>
                        </div>            
                    </div>   }                                          
                </div>
           </div>            
        </div>
        <Footer/>
    </>);
}

export default EditCampaign;